import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectEditProfile, setEditProfile } from '../store/editProfile/editProfileSlice';
import { useAppDispatch } from './redux';
import { useModal } from './useModal';

const useEditProfile = () => {
  const editProfile = useSelector(selectEditProfile);
  const dispatch = useAppDispatch();
  const { closeModal } = useModal();

  // hook cleanup: when user opens edit profile modal should close and form should reset
  useEffect(() => {
    if (editProfile) {
      closeModal();
    }
  }, [editProfile]);

  const openProfile = () => {
    dispatch(setEditProfile(true));
  };

  const closeProfile = () => {
    dispatch(setEditProfile(false));
  };

  return {
    editProfile,
    openProfile,
    closeProfile,
  };
};

export default useEditProfile;
